import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {newGuid, parseOptions} from '../question-helper';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';

declare var accounting: any;
declare const $: any;

@Component({
    selector: 'app-question-dropdown-currency',
    templateUrl: './question-dropdown-currency.component.html',
    styleUrls: ['./question-dropdown-currency.component.scss'],
    standalone: false
})
export class QuestionDropdownCurrencyComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() labelText: string;
  @Input() showLabel = false;
  @Input() showOptionLabel = false;
  @Input() readOnly = false;
  @Input() options: any[];
  @Input() selectedValue: any;
  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();

  uniqueControlName = `select-${newGuid()}`;
  uniqueControlId = `select-id-${newGuid()}`;
  accounting: any;
  constructor(public globalQuestionService: GlobalQuestionService,) {
  }

  ngOnInit(): void {

    if (this.question && this.question?.options) {
      this.options = parseOptions(this.question.options);
    }
    if (this.options?.length) {
      // const optionIndex = this.options.findIndex(o => o.hasOwnProperty('value') && !o?.value?.length);
      // if (optionIndex > -1) {
      //   this.options.splice(optionIndex, 1);
      // }
    }
  }

  ngAfterViewInit(): void {

    this.initCustomSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes?.question?.currentValue) {
      this.options = parseOptions(changes?.question?.currentValue?.options);
    }
    if (changes?.options?.currentValue) {
      this.options = changes?.options?.currentValue;
    }

    if (changes?.selectedValue?.currentValue) {
      this.selectedValue = changes?.selectedValue?.currentValue;
    }
    if (this.options?.length) {
      // const optionIndex = this.options.findIndex(o => o.hasOwnProperty('value') && !o?.value?.length);
      // if (optionIndex > -1) {
      //   this.options.splice(optionIndex, 1);
      // }
    }
    if ($(`#${this.uniqueControlId}`).selectmenu('instance')
      && (changes?.options?.currentValue
        || changes?.question?.currentValue
        || changes?.selectedValue?.currentValue)
    ) {
      setTimeout(() => {
        if (this.selectedValue) {
          $(`#${this.uniqueControlId}`).selectmenu('refresh', true).removeClass('is-placeholder');
        } else {
          $(`#${this.uniqueControlId}`).selectmenu('refresh');
        }
      }, 200);
    }

  }

  getValue(option: any): string {
    if (option.hasOwnProperty('value')) {
      return option?.value;
    } else if (option.hasOwnProperty('answer')) {
      return option.answer;
    } else if (option.hasOwnProperty('rate_id')) {
      return option.rate_id;
    }
    return option;
  }

  getOptionText(option: any): string {
    if (option.hasOwnProperty('label')) {
      return option.label;
    } else if (option.hasOwnProperty('answer')) {
      return option.answer;
    } else if (option.hasOwnProperty('rate_name')) {
      return option.rate_name;
    }
    return option;
  }

  formatOptionText(option: any): string {
    const optionText = this.getOptionText(option);
    const numericValue = Number(String(optionText).replace(/[^\d.-]/g, ''));

    if (Number.isNaN(numericValue)) {
      return optionText;
    }

    const accountingLib = this.globalQuestionService?.accounting || (globalThis as any)?.accounting;
    if (accountingLib?.formatMoney) {
      return accountingLib.formatMoney(numericValue);
    }

    return new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(numericValue);
  }

  getSelectedOption(option: any): any {

      if ((option.hasOwnProperty('value') && option?.value == this.selectedValue)
        || (option.hasOwnProperty('answer') && option.answer == this.question?.answer)
        || (option.hasOwnProperty('answer') && option.answer == this.selectedValue)
        || (option.hasOwnProperty('rate_id') && option.rate_id.toString() == this.selectedValue)
        || (option === this.selectedValue)) {
        return option;
      }
      return '';
  }

  initCustomSelect(): void {
    $(`#${this.uniqueControlId}`).selectmenu({
      change: (event, data) => {
        if (data?.item?.value) {
          if (this.question) {
            this.question.answer = data?.item?.value;
            this.questionAnswer.emit(this.question);
          } else {
            this.questionAnswer.emit(data?.item?.value);
          }
        }
        else{
          this.questionAnswer.emit(null);
        }
      }
    });
  }

}
